// extracted by mini-css-extract-plugin
export default {"wrapper":"SideMenu_wrapper__NxqWU","menuItem":"SideMenu_menuItem__6GMYH","closeItem":"SideMenu_closeItem__uqtAO","closeButton":"SideMenu_closeButton__JChXf"};